export function globToRegexp(inputGlob: string): RegExp {
    const pathTokens = inputGlob.split("/");
    return new RegExp(
        "^" +
            pathTokens
                .map((x, index) => {
                    if (x === "*") {
                        if (index === pathTokens.length - 1) {
                            return ".*$";
                        }
                        return "[^\\/]*?";
                    }
                    if (x === "**") {
                        if (index === pathTokens.length - 1) {
                            return ".*$";
                        }
                        return ".*?";
                    }
                    if (x.includes("*")) {
                        return x.replace("*", "[^\\/]*?");
                    }
                    return x;
                })
                .join("[\\/\\\\]")
    );
}
